import React from 'react'
import PropTypes from 'prop-types'
import { Button, TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CloseIcon from '@material-ui/icons/Close'
import styles from './ProductTransaction.module.css'

class DeliveryProductTransactionForm extends React.Component {
  render() {
    return (
      <>
        {
          <div>
            <form>
              <div className={styles.groupTextfield}>
                <div className={styles.addressBody}>
                  <div>
                    Option :
                  </div>
                  <div>
                    { this.props.initialProductTransaction.option }
                  </div>
                </div>

                <div className={styles.addressBody}>
                  <div className={styles.referenceNumber}>
                    Delivery Number :
                  </div>
                  <div>
                    { this.props.initialProductTransaction.delivery_no }
                  </div>
                </div>
              </div>

              <div className={styles.groupTextfield}>
                <div className={styles.autoCompleteField}>
                  <Autocomplete
                    name="delivery_detail_id"
                    id="delivery_detail_id"
                    key="delivery_detail"
                    size="small"
                    options={this.props.deliveryDetails}
                    disabled={this.props.deliveryDetails.length < 1}
                    getOptionLabel={(option) => option ? option.invoice_no + ' - ' + option.description : ''}
                    getOptionSelected={(option, value) => option.id === value.id}
                    onChange={this.props.handleAutocomplete}
                    fullWidth={true}
                    value={this.props.initialProductTransaction.delivery_detail}
                    closeIcon={<CloseIcon fontSize="small" id="clear_delivery_detail_autocomplete" />}
                    renderInput={(params) => <TextField {...params} label="Invoice Number - Product Category Description" variant="outlined" required />}
                  />
                </div>

                <div className={styles.autoCompleteField}>
                  <Autocomplete
                    name="product_id"
                    id="product_id"
                    key="product"
                    size="small"
                    disabled={this.props.products.length < 1}
                    options={this.props.products}
                    getOptionLabel={(option) => option ? option.name : ''}
                    getOptionSelected={(option, value) => option.id === value.id}
                    onChange={this.props.handleAutocomplete}
                    fullWidth={true}
                    value={this.props.initialProductTransaction.product}
                    closeIcon={<CloseIcon fontSize="small" id="clear_product_autocomplete" />}
                    renderInput={(params) => <TextField {...params} label="Product" variant="outlined" required />}
                  />
                </div>
              </div>

              <div className={styles.groupTextfield}>
                <div className={styles.addressBody}>
                  <div>
                    Client Name :
                  </div>
                  <div>
                    { this.props.client.name }
                  </div>
                </div>

                <div className={styles.addressBody}>
                  <div>
                    Address :
                  </div>
                  <div>
                    { this.props.client.company_address || this.props.client.home_address }
                  </div>
                </div>
              </div>

              <div className={styles.groupTextfield}>
                <div className={styles.autoCompleteField}>
                  <Autocomplete
                    name="employee_id"
                    id="employee_id"
                    key="employee"
                    size="small"
                    disabled={this.props.employees.length < 1}
                    options={(this.props.employees).sort(function (a, b) {
                      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                      return 0;
                    })}
                    getOptionLabel={(option) => option.name || ''}
                    getOptionSelected={(option, value) => option.name === value.name}
                    onChange={this.props.handleAutocomplete}
                    fullWidth={true}
                    value={this.props.initialProductTransaction.employee}
                    closeIcon={<CloseIcon fontSize="small" id="clear_employee_autocomplete" />}
                    renderInput={(params) => <TextField {...params} label="FSCR" variant="outlined" required />}
                  />
                </div>

                <TextField
                  autoComplete="off"
                  className={styles.textFields}
                  type="date"
                  variant="outlined"
                  size="small"
                  required
                  name="date_of_password"
                  fullWidth={true}
                  label="Date Password Given"
                  onChange={this.props.handleInputChange}
                  value={this.props.initialProductTransaction.date_of_password}
                  id="date_of_password"
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </div>

              <div className={styles.groupTextfield}>
                <TextField
                  autoComplete="off"
                  variant="outlined"
                  className={styles.textFields}
                  multiline={true}
                  size="sm"
                  required
                  name="reason"
                  id="reason"
                  fullWidth={true}
                  label="Reason"
                  onChange={this.props.handleInputChange}
                  value={this.props.initialProductTransaction.reason}
                  InputProps={{
                    shrink: true
                  }}
                />

                <TextField
                  autoComplete="off"
                  variant="outlined"
                  className={styles.textFields}
                  multiline={true}
                  size="sm"
                  required
                  name="status"
                  id="status"
                  fullWidth={true}
                  label="Status"
                  onChange={this.props.handleInputChange}
                  value={this.props.initialProductTransaction.status}
                  InputProps={{
                    shrink: true
                  }}
                />
              </div>

              <div className={styles.actionButton}>
                <Button variant="outlined" id="product_transaction_submit" color="primary" onClick={this.props.handleSaveProductTransaction}>Save</Button>
              </div>
            </form>
          </div>
        }
      </>
    )
  }
}
export default DeliveryProductTransactionForm

DeliveryProductTransactionForm.propTypes = {
  client: PropTypes.object,
  deliveryDetails: PropTypes.array,
  employees: PropTypes.array,
  products: PropTypes.array,
  initialProductTransaction: PropTypes.object,
  handleAutocomplete: PropTypes.func,
  handleInputChange: PropTypes.func,
  handleSaveProductTransaction: PropTypes.func
}